let mm = gsap.matchMedia()
    mm.add("(min-width: 1024px)", () => {
        Marquee3k.init({
            selector: 'marquee-desktop',
        })
    })
    mm.add("(max-width: 1023px)", () => {
        Marquee3k.init({
            selector: 'marquee-mobile',
        })
    })